// packages/world-model/src/traits/light-source/lightSourceTrait.ts

import { ITrait } from '../trait';
import { TraitType } from '../trait-types';

/**
 * LightSource trait allows entities to provide illumination.
 * 
 * This is a pure data structure - all validation and logic
 * should be handled by LightSourceBehavior.
 */
export class LightSourceTrait implements ITrait {
  static readonly type = TraitType.LIGHT_SOURCE;
  readonly type = TraitType.LIGHT_SOURCE;
  
  /** Light output level (1-10) */
  brightness: number = 5;

  /**
   * Whether the light is currently providing illumination.
   * - true: explicitly lit
   * - false: explicitly not lit
   * - undefined: use switchable state or default to lit
   */
  isLit?: boolean;
  
  /** Optional fuel/battery remaining (undefined = infinite) */
  fuelRemaining?: number;
  
  /** Maximum fuel capacity (for refillable lights) */
  maxFuel?: number;
  
  /** Fuel consumption rate per turn (when lit) */
  fuelConsumptionRate?: number;

  /** Description when lit (used by computed description getter on IFEntity) */
  litDescription?: string;

  /** Description when unlit (used by computed description getter on IFEntity) */
  unlitDescription?: string;

  constructor(data?: Partial<LightSourceTrait>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}
